import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { AveriasService } from '../servicios/averias.service';
import { SelectItem } from 'primeng/api';
import { Severidad } from '../entidades/entidades.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent} from '../snack-bar/snack-bar.component';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { DatePipe } from '@angular/common';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { NbCheckboxModule } from '@nebular/theme';
@Component({
    selector: 'app-severidad',
    templateUrl: './severidad.component.html',
    styleUrls: ['./severidad.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,
          MatCardModule,MatFormFieldModule,MatInputModule,SpinnerComponent,
          AngularSlickgridModule,NbTabsetModule, AgGridAngular,NbCheckboxModule],
    providers: [DatePipe],
})
export class SeveridadComponent implements OnInit {
  durationInSeconds = 3;
  checked = false;
  firstForm: UntypedFormGroup;
  severidadOK = false;
  severidad: SelectItem[];
  showSeveridad = false;
  IdSeveridad: number;
  severidadProcesado;
  descripcionSeveridad;
  descripcionBreve;
  codigoExterno;
  severidadCompleto;
  descripcionBreveEditar;
  descripcionSeveridadEditar;
  codigoExternoEditar;
  loadingResponseSeveridad = false;
  datasetSeveridad: any[] = [];
  angularGridSeveridad: AngularGridInstance;
  angularGridSeveridadModificar: AngularGridInstance;
  datasetSeveridadConsulta: any[] = [];
  datasetSeveridadModificar: any[] = [];
  angularGridSeveridadConsulta: AngularGridInstance;
  columnDefinitionsSeveridad: ColDef[];//Column[];
  columnDefinitionsSeveridadModificar: ColDef[];//Column[];
  gridOptionsSeveridad: GridOption;
  gridOptionsSeveridadModificar: GridOption;
  columnDefinitionsSeveridadConsulta: ColDef[]//Column[];
  gridOptionsSeveridadConsulta: GridOption;
  gridObjSeveridad: any;
  showGrilla = false;
  showSpinner = false;
  showGrillaModificar = false;
  showSpinnerModificarGrilla = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  idCliente:number;
  eliminar = false;
  eliminarSeleccionado;
  showSpinnerConsulta = false;
  showGrillaConsulta = false;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
@ViewChild('grilla2') grilla2!: AgGridAngular;
@ViewChild('grilla3') grilla3!: AgGridAngular;
  
  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.idCliente = Number( localStorage.getItem("idCliente"));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.svcAnalytics.setAnalyticsPageView();
  }

  ngAfterViewInit():void {

  }
  
  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarSeveridad();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarSeveridadConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarSeveridadModificar();
    }
  }

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarSeveridad() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getSeveridad(this.idCliente).subscribe(
      data => {
        this.severidadCompleto = data;
        this.severidad = this.insertarSeveridad(data);
        this.traerDatosSeveridad();
        this.fillGrillaSeveridad();
      });
  }

  consultarSeveridadConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    this.AveriasService.getSeveridad(this.idCliente).subscribe(
      data => {
        this.severidadCompleto = data;
        this.traerDatosSeveridadConsulta();
        this.fillGrillaSeveridadConsulta();
      });
  }

  consultarSeveridadModificar() {
    this.showSpinnerModificarGrilla = true;
    this.showGrillaModificar = false;
    this.AveriasService.getSeveridad(this.idCliente).subscribe(
      data => {
        this.severidadCompleto = data;
        this.severidad = this.insertarSeveridad(data);
        this.traerDatosSeveridadModificar();
        this.fillGrillaSeveridadModificar();
      });
  }
  insertarSeveridad(armarSeveridad) {
    let averiasSeveridad: Array<any> = [];
    armarSeveridad.content.forEach(element => {
      averiasSeveridad.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasSeveridad;
  };
  capturarSeveridad(event) {
    this.IdSeveridad = event;
    this.severidadOK = true;
  }
  altaSeveridad() {
    let severidad: Severidad;

    if (this.descripcionSeveridad == null || this.descripcionSeveridad == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe Completar el Código Externo ❌");
    } else {
      severidad = {
        descripcion: this.descripcionSeveridad,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        idCliente: this.idCliente
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postSeveridad(severidad).subscribe(data => {
        if(data["status"] == 201){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.descripcionSeveridad = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.consultarSeveridad();
        this.showSpinnerGuardar = false;
      })
    }
  }
  modificarSeveridad() {
    let severidad: Severidad ;
    
    if (this.eliminar) {
      this.AveriasService.deleteSeveridad(this.severidadProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionSeveridadEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.severidadProcesado = '';
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarSeveridadModificar();
      })
    } else {
      if (this.descripcionSeveridadEditar == null || this.descripcionSeveridadEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        severidad = {
          descripcion: this.descripcionSeveridadEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          idCliente: this.idCliente,
      }
      this.AveriasService.putSeveridad(this.severidadProcesado, severidad).subscribe(data =>{
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.showSpinnerModificar = false;
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarSeveridadModificar();
      })
      this.descripcionSeveridadEditar = '';
      this.descripcionBreveEditar = '';
      this.codigoExternoEditar = '';
      this.severidadProcesado = '';
      this.eliminarSeleccionado = false;
      
    }
    }
  }
  obtenerDescripcionDropdown(IdSeveridad: number) {
    let resp = this.severidadCompleto.content.find(n => n['id'] == IdSeveridad);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionSeveridadEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.eliminarSeleccionado = false;
  }
  //Grilla Severidad
  traerDatosSeveridad() {
    let DatosSeveridad = this.severidadCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosSeveridad.length; i++) {
      mockDataset.push({
        id: DatosSeveridad[i]["id"],
        Descripcion: DatosSeveridad[i]["descripcion"],
        DescripcionAbreviada: DatosSeveridad[i]["descripcionAbreviada"],
        Codigo: DatosSeveridad[i]["codigoExterno"],
      });
    }
    this.datasetSeveridad  = mockDataset;
    this.showSpinner = false;
    this.showGrilla = true;
  }

  traerDatosSeveridadConsulta() {
    let DatosSeveridad = this.severidadCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosSeveridad.length; i++) {
      mockDataset.push({
        id: DatosSeveridad[i]["id"],
        Descripcion: DatosSeveridad[i]["descripcion"],
        DescripcionAbreviada: DatosSeveridad[i]["descripcionAbreviada"],
        Codigo: DatosSeveridad[i]["codigoExterno"],
      });
    }
    this.datasetSeveridadConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrillaConsulta = true;
  }

  traerDatosSeveridadModificar() {
    let DatosSeveridad = this.severidadCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosSeveridad.length; i++) {
      mockDataset.push({
        id: DatosSeveridad[i]["id"],
        Descripcion: DatosSeveridad[i]["descripcion"],
        DescripcionAbreviada: DatosSeveridad[i]["descripcionAbreviada"],
        Codigo: DatosSeveridad[i]["codigoExterno"],
      });
    }
    this.datasetSeveridadModificar  = mockDataset;
    this.showSpinnerModificarGrilla = false;
    this.showGrillaModificar = true;
  }

  fillGrillaSeveridad() {
    this.columnDefinitionsSeveridad = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo', 
        headerName: 'Código Externo', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
    ];
    this.gridOptionsSeveridad = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaSeveridadConsulta() {
    this.columnDefinitionsSeveridadConsulta = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo', 
        headerName: 'Código Externo', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
    ];
    this.gridOptionsSeveridadConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  fillGrillaSeveridadModificar() {
    this.columnDefinitionsSeveridadModificar = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo',
        headerName: 'Código Externo', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 30, width: 30},
    ];
    this.gridOptionsSeveridadModificar = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }

  angularGridReadySeveridad(angularGrid: AngularGridInstance){
    this.angularGridSeveridad = angularGrid;
    this.angularGridSeveridad.resizerService.pauseResizer(false)
  }

  angularGridReadySeveridadConsulta(angularGrid: AngularGridInstance){
    this.angularGridSeveridadConsulta = angularGrid;
    this.angularGridSeveridadConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadySeveridadModificar(angularGrid: AngularGridInstance){
    this.angularGridSeveridadModificar = angularGrid;
    this.angularGridSeveridadModificar.resizerService.pauseResizer(false)
  }



    exportToExcelSeveridad(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Severidad': worksheet },
          SheetNames: ['Severidad']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Severidad_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }


}
